export default __webpack_public_path__ + "static/c11-f734cc3554bdcda516f140d8f33bec82.png";